<template>
  <div class="machineCamera table-responsive col-12 mb-2">
    <div class="text-left">
      <template v-if="machineCameraData.length == 0">
        本機無掛載影像攝相機
      </template>
      <template v-else-if="machineCameraData.length > 1">
        <b-button
          v-for="(item, key) in machineCameraData"
          :key="key"
          style=""
          class="mr-2 my-1 machineCameraData"
          :class="{ select_button: camera_button == item.camera_name }"
          @click="
            changeCamera(item.camera_name), (camera_button = item.camera_name)
          "
          >{{ item.camera_name }}</b-button
        >
        <b-button
          style=""
          class="mr-2 my-1 machineCameraData"
          :class="{ select_button: camera_button == 'ALL' }"
          @click="changeCamera('ALL'), (camera_button = 'ALL')"
          >ALL</b-button
        >
      </template>
    </div>
    <div
      v-if="machineCameraData.length != 0"
      class="col-12 row p-0 mx-0 mb-2"
      style="margin-top: 1.125rem"
    >
      <template v-if="allCamera">
        <img
          v-for="(item, key) in machineCameraData"
          :key="key"
          :id="item.camera_name"
          :src="item.url"
          alt="機台關機中"
          class="mr-3"
          style="height: 31.25rem; border-radius: 0.625rem"
        />
      </template>
      <template v-else>
        <img
          :id="camera_name"
          :src="camera_url"
          alt="機台關機中"
          style="height: 31.25rem; border-radius: 0.625rem"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "machineCamera",
  data() {
    return {
      allCamera: false,
      camera_name: "",
      camera_url: "",
      machineCameraDetail: {},
      camera_button: 0,
    };
  },
  created: function () {
    // let vm = this;
    // vm.setMachineCameraData();
  },
  mounted: function () {},
  watch: {
    machineCameraData: {
      handler() {
        let vm = this;
        vm.setMachineCameraData();
      },
    },
  },
  computed: {
    ...mapGetters({
      machineCameraData: "machineCamera/get_machineCameraData",
    }),
  },
  methods: {
    setMachineCameraData() {
      let vm = this;
      if (vm.machineCameraData.length > 0) {
        vm.machineCameraData.forEach((data) => {
          vm.machineCameraDetail[data.camera_name] = data.url;
        });
        vm.camera_name = vm.machineCameraData[0]["camera_name"];
        vm.camera_url = vm.machineCameraData[0]["url"];
        vm.camera_button = vm.camera_name;
      } else {
        vm.machineCameraDetail = null;
      }
    },
    changeCamera(data) {
      let vm = this;
      if (data == "ALL") {
        vm.allCamera = true;
      } else {
        vm.allCamera = false;
        vm.camera_name = data;
        vm.camera_url = vm.machineCameraDetail[data];
      }
    },
  },
};
</script>

<style scoped>
.machineCameraData.select_button {
  background-color: #4b8c80;
  border-color: #4b8c80;
}
</style>
<style lang="scss">
.machineCameraData {
  height: 2rem;
  line-height: 2rem;
  width: 4.25rem;
  padding: 0px;
  background-color: #cccccc;
  color: #ffffff;
  border-color: #cccccc;
}
</style>



// WEBPACK FOOTER //
// src/components/machineCamera.vue